// @ts-ignore
import * as XLSX from 'xlsx';
import { Motor, Battery, Propeller, SystemConfig, AnalysisResult } from '../types';

// 生成唯一ID的工具函数
const generateId = () => {
  return Date.now().toString(36) + Math.random().toString(36).substr(2);
};

export const exportToExcel = (
  motors: Motor[],
  batteries: Battery[],
  propellers: Propeller[],
  config: SystemConfig,
  analysisResults: AnalysisResult[],
  filename: string = '无人机动力系统分析报告'
) => {
  const wb = XLSX.utils.book_new();

  // 系统配置工作表
  const systemConfig: any[][] = [
    ['参数', '数值', '单位'],
    ['目标起飞重量', config.targetWeight, 'kg'],
    ['其他设备功耗', config.otherPower, 'W'],
    ['最低推重比', config.thrustRatio, ''],
    ['桨叶数量选择', config.bladeCount, '叶'],
    ['电机数量', '2', '个']
  ];
  const ws1 = XLSX.utils.aoa_to_sheet(systemConfig);
  XLSX.utils.book_append_sheet(wb, ws1, "系统配置");

  // 电机数据工作表
  const motorHeaders = ['品牌', '型号', 'KV值', '最大功率(W)', '重量(g)', '直径(mm)', '高度(mm)', '推荐桨叶', '最大推力(g)', '最大电流(A)', '价格(¥)', '备注'];
  const motorArray: any[][] = [motorHeaders];
  motors.forEach(motor => {
    motorArray.push([motor.brand, motor.model, motor.kv, motor.maxPower, motor.weight, motor.diameter, motor.height, motor.recommendedProp, motor.maxThrust, motor.maxCurrent, motor.price, motor.notes]);
  });
  const ws2 = XLSX.utils.aoa_to_sheet(motorArray);
  XLSX.utils.book_append_sheet(wb, ws2, "电机数据库");

  // 电池数据工作表
  const batteryHeaders = ['品牌', '型号', '电芯数', '容量(mAh)', '标称电压(V)', '能量(Wh)', '重量(g)', '放电倍率(C)', '尺寸(mm)', '价格(¥)', '备注'];
  const batteryArray: any[][] = [batteryHeaders];
  batteries.forEach(battery => {
    batteryArray.push([battery.brand, battery.model, battery.cells, battery.capacity, battery.voltage, battery.energy, battery.weight, battery.discharge, battery.size, battery.price, battery.notes]);
  });
  const ws3 = XLSX.utils.aoa_to_sheet(batteryArray);
  XLSX.utils.book_append_sheet(wb, ws3, "电池数据库");

  // 桨叶数据工作表
  const propHeaders = ['品牌', '规格', '直径(英寸)', '螺距(英寸)', '叶片数', '重量(g)', '材质', '推力系数', '功率系数', '效率(%)', '价格(¥)', '备注'];
  const propArray: any[][] = [propHeaders];
  propellers.forEach(prop => {
    propArray.push([prop.brand, prop.spec, prop.diameter, prop.pitch, prop.blades, prop.weight, prop.material, prop.thrustCoeff, prop.powerCoeff, prop.efficiency, prop.price, prop.notes]);
  });
  const ws4 = XLSX.utils.aoa_to_sheet(propArray);
  XLSX.utils.book_append_sheet(wb, ws4, "桨叶数据库");

  // 对比分析工作表
  if (analysisResults.length > 0) {
    const analysisHeaders = ['排序', '电机型号', '电池型号', '桨叶规格', '总推力(g)', '推力冗余(%)', '总重量(g)', '系统功率(W)', '续航时间(min)', '系统效率', 'ESC规格', '总成本(¥)', '综合评分'];
    const analysisArray: any[][] = [analysisHeaders];
    analysisResults.forEach((result, index) => {
      analysisArray.push([index + 1, result.motor, result.battery, result.propeller, result.totalThrust, result.thrustMargin, result.totalWeight, result.systemPower, result.endurance, result.efficiency, result.escSpec, result.totalCost, result.score]);
    });
    const ws5 = XLSX.utils.aoa_to_sheet(analysisArray);
    XLSX.utils.book_append_sheet(wb, ws5, "对比分析");
  }

  // 导出文件
  XLSX.writeFile(wb, filename + '.xlsx');
};

export const exportProjectData = (
  motors: Motor[],
  batteries: Battery[],
  propellers: Propeller[],
  config: SystemConfig
) => {
  const wb = XLSX.utils.book_new();

  // 系统配置工作表
  const systemConfigData: any[][] = [
    ['参数', '数值', '单位', '说明'],
    ['目标起飞重量', config.targetWeight, 'kg', '无人机总重量目标'],
    ['其他设备功耗', config.otherPower, 'W', '飞控、图传等设备功耗'],
    ['最低推重比', config.thrustRatio, '', '安全飞行所需推重比'],
    ['桨叶数量选择', config.bladeCount, '叶', '每个电机的桨叶数量'],
    ['电机数量', '2', '个', '共轴双桨配置'],
    ['项目版本', '1.0', '', '数据格式版本'],
    ['导出时间', new Date().toISOString().split('T')[0], '', '数据导出日期']
  ];
  const ws1 = XLSX.utils.aoa_to_sheet(systemConfigData);
  ws1['!cols'] = [{ wch: 15 }, { wch: 12 }, { wch: 8 }, { wch: 25 }];
  XLSX.utils.book_append_sheet(wb, ws1, "系统配置");

  // 电机数据工作表
  const motorHeaders = ['品牌', '型号', 'KV值', '最大功率(W)', '重量(g)', '直径(mm)', '高度(mm)', '推荐桨叶', '最大推力(g)', '最大电流(A)', '价格(¥)', '备注'];
  const motorData_export: any[][] = [motorHeaders];
  motors.forEach(motor => {
    motorData_export.push([motor.brand, motor.model, motor.kv, motor.maxPower, motor.weight, motor.diameter, motor.height, motor.recommendedProp, motor.maxThrust, motor.maxCurrent, motor.price, motor.notes]);
  });
  if (motors.length === 0) motorData_export.push(['', '', '', '', '', '', '', '', '', '', '', '']);
  const ws2 = XLSX.utils.aoa_to_sheet(motorData_export);
  ws2['!cols'] = [{ wch: 12 }, { wch: 15 }, { wch: 8 }, { wch: 12 }, { wch: 8 }, { wch: 10 }, { wch: 8 }, { wch: 15 }, { wch: 12 }, { wch: 12 }, { wch: 8 }, { wch: 20 }];
  XLSX.utils.book_append_sheet(wb, ws2, "电机数据");

  // 电池数据工作表
  const batteryHeaders = ['品牌', '型号', '电芯数', '容量(mAh)', '标称电压(V)', '能量(Wh)', '重量(g)', '放电倍率(C)', '尺寸(mm)', '价格(¥)', '备注'];
  const batteryData_export: any[][] = [batteryHeaders];
  batteries.forEach(battery => {
    batteryData_export.push([battery.brand, battery.model, battery.cells, battery.capacity, battery.voltage, battery.energy, battery.weight, battery.discharge, battery.size, battery.price, battery.notes]);
  });
  if (batteries.length === 0) batteryData_export.push(['', '', '', '', '', '', '', '', '', '', '']);
  const ws3 = XLSX.utils.aoa_to_sheet(batteryData_export);
  ws3['!cols'] = [{ wch: 12 }, { wch: 15 }, { wch: 8 }, { wch: 12 }, { wch: 12 }, { wch: 10 }, { wch: 8 }, { wch: 12 }, { wch: 15 }, { wch: 8 }, { wch: 20 }];
  XLSX.utils.book_append_sheet(wb, ws3, "电池数据");

  // 桨叶数据工作表
  const propellerHeaders = ['品牌', '规格', '直径(英寸)', '螺距(英寸)', '叶片数', '重量(g)', '材质', '推力系数', '功率系数', '效率(%)', '价格(¥)', '备注'];
  const propellerData_export: any[][] = [propellerHeaders];
  propellers.forEach(prop => {
    propellerData_export.push([prop.brand, prop.spec, prop.diameter, prop.pitch, prop.blades, prop.weight, prop.material, prop.thrustCoeff, prop.powerCoeff, prop.efficiency, prop.price, prop.notes]);
  });
  if (propellers.length === 0) propellerData_export.push(['', '', '', '', '', '', '', '', '', '', '', '']);
  const ws4 = XLSX.utils.aoa_to_sheet(propellerData_export);
  ws4['!cols'] = [{ wch: 12 }, { wch: 12 }, { wch: 12 }, { wch: 12 }, { wch: 8 }, { wch: 8 }, { wch: 10 }, { wch: 10 }, { wch: 10 }, { wch: 8 }, { wch: 8 }, { wch: 20 }];
  XLSX.utils.book_append_sheet(wb, ws4, "桨叶数据");

  // 导出文件
  const filename = '无人机项目数据_' + new Date().toISOString().split('T')[0];
  XLSX.writeFile(wb, filename + '.xlsx');
  
  return filename;
};

export const importProjectData = async (file: File): Promise<{
  motors: Motor[];
  batteries: Battery[];
  propellers: Propeller[];
  config?: Partial<SystemConfig>;
}> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = function(e) {
      try {
        const data = new Uint8Array(e.target!.result as ArrayBuffer);
        const workbook = XLSX.read(data, { type: 'array' });

        let result = {
          motors: [] as Motor[],
          batteries: [] as Battery[],
          propellers: [] as Propeller[],
          config: {} as Partial<SystemConfig>
        };

        // 导入系统配置
        if (workbook.SheetNames.includes('系统配置')) {
          const configSheet = workbook.Sheets['系统配置'];
          const configData = XLSX.utils.sheet_to_json(configSheet, { header: 1 }) as any[][];

          configData.forEach(row => {
            if (row[0] && row[1]) {
              switch (row[0]) {
                case '目标起飞重量':
                  result.config.targetWeight = parseFloat(row[1]) || 1.2;
                  break;
                case '其他设备功耗':
                  result.config.otherPower = parseFloat(row[1]) || 15;
                  break;
                case '最低推重比':
                  result.config.thrustRatio = parseFloat(row[1]) || 2.0;
                  break;
                case '桨叶数量选择':
                  result.config.bladeCount = parseInt(row[1]) || 2;
                  break;
              }
            }
          });
        }

        // 导入电机数据
        if (workbook.SheetNames.includes('电机数据')) {
          const motorSheet = workbook.Sheets['电机数据'];
          const motorJsonData = XLSX.utils.sheet_to_json(motorSheet, { header: 1 }) as any[][];

          for (let i = 1; i < motorJsonData.length; i++) {
            const row = motorJsonData[i];
            if (row[0] && row[1]) {
              result.motors.push({
                id: generateId(),
                brand: row[0] || '',
                model: row[1] || '',
                kv: parseFloat(row[2]) || 0,
                maxPower: parseFloat(row[3]) || 0,
                weight: parseFloat(row[4]) || 0,
                diameter: parseFloat(row[5]) || 0,
                height: parseFloat(row[6]) || 0,
                recommendedProp: row[7] || '',
                maxThrust: parseFloat(row[8]) || 0,
                maxCurrent: parseFloat(row[9]) || 0,
                price: parseFloat(row[10]) || 0,
                notes: row[11] || ''
              });
            }
          }
        }

        // 导入电池数据
        if (workbook.SheetNames.includes('电池数据')) {
          const batterySheet = workbook.Sheets['电池数据'];
          const batteryJsonData = XLSX.utils.sheet_to_json(batterySheet, { header: 1 }) as any[][];

          for (let i = 1; i < batteryJsonData.length; i++) {
            const row = batteryJsonData[i];
            if (row[0] && row[1]) {
              result.batteries.push({
                id: generateId(),
                brand: row[0] || '',
                model: row[1] || '',
                cells: parseInt(row[2]) || 4,
                capacity: parseFloat(row[3]) || 0,
                voltage: parseFloat(row[4]) || 0,
                energy: parseFloat(row[5]) || 0,
                weight: parseFloat(row[6]) || 0,
                discharge: parseFloat(row[7]) || 0,
                size: row[8] || '',
                price: parseFloat(row[9]) || 0,
                notes: row[10] || ''
              });
            }
          }
        }

        // 导入桨叶数据
        if (workbook.SheetNames.includes('桨叶数据')) {
          const propellerSheet = workbook.Sheets['桨叶数据'];
          const propellerJsonData = XLSX.utils.sheet_to_json(propellerSheet, { header: 1 }) as any[][];

          for (let i = 1; i < propellerJsonData.length; i++) {
            const row = propellerJsonData[i];
            if (row[0] && row[1]) {
              result.propellers.push({
                id: generateId(),
                brand: row[0] || '',
                spec: row[1] || '',
                diameter: parseFloat(row[2]) || 0,
                pitch: parseFloat(row[3]) || 0,
                blades: parseInt(row[4]) || 2,
                weight: parseFloat(row[5]) || 0,
                material: row[6] || '',
                thrustCoeff: parseFloat(row[7]) || 0,
                powerCoeff: parseFloat(row[8]) || 0,
                efficiency: parseFloat(row[9]) || 0,
                price: parseFloat(row[10]) || 0,
                notes: row[11] || ''
              });
            }
          }
        }

        resolve(result);
      } catch (error) {
        reject(error);
      }
    };
    reader.readAsArrayBuffer(file);
  });
};

// 单独组件导出功能
export const exportMotors = (motors: Motor[]) => {
  const wb = XLSX.utils.book_new();
  
  const motorHeaders = ['品牌', '型号', 'KV值', '最大功率(W)', '重量(g)', '直径(mm)', '高度(mm)', '推荐桨叶', '最大推力(g)', '最大电流(A)', '价格(¥)', '备注'];
  const motorData: any[][] = [motorHeaders];
  
  motors.forEach(motor => {
    motorData.push([motor.brand, motor.model, motor.kv, motor.maxPower, motor.weight, motor.diameter, motor.height, motor.recommendedProp, motor.maxThrust, motor.maxCurrent, motor.price, motor.notes]);
  });
  
  if (motors.length === 0) motorData.push(['', '', '', '', '', '', '', '', '', '', '', '']);
  
  const ws = XLSX.utils.aoa_to_sheet(motorData);
  ws['!cols'] = [{ wch: 12 }, { wch: 15 }, { wch: 8 }, { wch: 12 }, { wch: 8 }, { wch: 10 }, { wch: 8 }, { wch: 15 }, { wch: 12 }, { wch: 12 }, { wch: 8 }, { wch: 20 }];
  XLSX.utils.book_append_sheet(wb, ws, "电机数据");
  
  const filename = '电机数据_' + new Date().toISOString().split('T')[0];
  XLSX.writeFile(wb, filename + '.xlsx');
  
  return filename;
};

export const exportBatteries = (batteries: Battery[]) => {
  const wb = XLSX.utils.book_new();
  
  const batteryHeaders = ['品牌', '型号', '电芯数', '容量(mAh)', '标称电压(V)', '能量(Wh)', '重量(g)', '放电倍率(C)', '尺寸(mm)', '价格(¥)', '备注'];
  const batteryData: any[][] = [batteryHeaders];
  
  batteries.forEach(battery => {
    batteryData.push([battery.brand, battery.model, battery.cells, battery.capacity, battery.voltage, battery.energy, battery.weight, battery.discharge, battery.size, battery.price, battery.notes]);
  });
  
  if (batteries.length === 0) batteryData.push(['', '', '', '', '', '', '', '', '', '', '']);
  
  const ws = XLSX.utils.aoa_to_sheet(batteryData);
  ws['!cols'] = [{ wch: 12 }, { wch: 15 }, { wch: 8 }, { wch: 12 }, { wch: 12 }, { wch: 10 }, { wch: 8 }, { wch: 12 }, { wch: 15 }, { wch: 8 }, { wch: 20 }];
  XLSX.utils.book_append_sheet(wb, ws, "电池数据");
  
  const filename = '电池数据_' + new Date().toISOString().split('T')[0];
  XLSX.writeFile(wb, filename + '.xlsx');
  
  return filename;
};

export const exportPropellers = (propellers: Propeller[]) => {
  const wb = XLSX.utils.book_new();
  
  const propellerHeaders = ['品牌', '规格', '直径(英寸)', '螺距(英寸)', '叶片数', '重量(g)', '材质', '推力系数', '功率系数', '效率(%)', '价格(¥)', '备注'];
  const propellerData: any[][] = [propellerHeaders];
  
  propellers.forEach(prop => {
    propellerData.push([prop.brand, prop.spec, prop.diameter, prop.pitch, prop.blades, prop.weight, prop.material, prop.thrustCoeff, prop.powerCoeff, prop.efficiency, prop.price, prop.notes]);
  });
  
  if (propellers.length === 0) propellerData.push(['', '', '', '', '', '', '', '', '', '', '', '']);
  
  const ws = XLSX.utils.aoa_to_sheet(propellerData);
  ws['!cols'] = [{ wch: 12 }, { wch: 12 }, { wch: 12 }, { wch: 12 }, { wch: 8 }, { wch: 8 }, { wch: 10 }, { wch: 10 }, { wch: 10 }, { wch: 8 }, { wch: 8 }, { wch: 20 }];
  XLSX.utils.book_append_sheet(wb, ws, "桨叶数据");
  
  const filename = '桨叶数据_' + new Date().toISOString().split('T')[0];
  XLSX.writeFile(wb, filename + '.xlsx');
  
  return filename;
};

// 单独组件导入功能
export const importMotors = async (file: File): Promise<Motor[]> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = function(e) {
      try {
        const data = new Uint8Array(e.target!.result as ArrayBuffer);
        const workbook = XLSX.read(data, { type: 'array' });
        
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }) as any[][];
        
        // 验证表头
        const headers = jsonData[0];
        const expectedHeaders = ['品牌', '型号', 'KV值', '最大功率(W)', '重量(g)', '直径(mm)', '高度(mm)', '推荐桨叶', '最大推力(g)', '最大电流(A)', '价格(¥)', '备注'];
        
        if (!validateHeaders(headers, expectedHeaders)) {
          throw new Error('电机数据Excel表头格式不正确');
        }
        
        const motors: Motor[] = [];
        for (let i = 1; i < jsonData.length; i++) {
          const row = jsonData[i];
          if (row[0] && row[1]) {
            motors.push({
              id: generateId(),
              brand: row[0] || '',
              model: row[1] || '',
              kv: parseFloat(row[2]) || 0,
              maxPower: parseFloat(row[3]) || 0,
              weight: parseFloat(row[4]) || 0,
              diameter: parseFloat(row[5]) || 0,
              height: parseFloat(row[6]) || 0,
              recommendedProp: row[7] || '',
              maxThrust: parseFloat(row[8]) || 0,
              maxCurrent: parseFloat(row[9]) || 0,
              price: parseFloat(row[10]) || 0,
              notes: row[11] || ''
            });
          }
        }
        
        resolve(motors);
      } catch (error) {
        reject(error);
      }
    };
    reader.readAsArrayBuffer(file);
  });
};

export const importBatteries = async (file: File): Promise<Battery[]> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = function(e) {
      try {
        const data = new Uint8Array(e.target!.result as ArrayBuffer);
        const workbook = XLSX.read(data, { type: 'array' });
        
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }) as any[][];
        
        // 验证表头
        const headers = jsonData[0];
        const expectedHeaders = ['品牌', '型号', '电芯数', '容量(mAh)', '标称电压(V)', '能量(Wh)', '重量(g)', '放电倍率(C)', '尺寸(mm)', '价格(¥)', '备注'];
        
        if (!validateHeaders(headers, expectedHeaders)) {
          throw new Error('电池数据Excel表头格式不正确');
        }
        
        const batteries: Battery[] = [];
        for (let i = 1; i < jsonData.length; i++) {
          const row = jsonData[i];
          if (row[0] && row[1]) {
            batteries.push({
              id: generateId(),
              brand: row[0] || '',
              model: row[1] || '',
              cells: parseInt(row[2]) || 4,
              capacity: parseFloat(row[3]) || 0,
              voltage: parseFloat(row[4]) || 0,
              energy: parseFloat(row[5]) || 0,
              weight: parseFloat(row[6]) || 0,
              discharge: parseFloat(row[7]) || 0,
              size: row[8] || '',
              price: parseFloat(row[9]) || 0,
              notes: row[10] || ''
            });
          }
        }
        
        resolve(batteries);
      } catch (error) {
        reject(error);
      }
    };
    reader.readAsArrayBuffer(file);
  });
};

export const importPropellers = async (file: File): Promise<Propeller[]> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = function(e) {
      try {
        const data = new Uint8Array(e.target!.result as ArrayBuffer);
        const workbook = XLSX.read(data, { type: 'array' });
        
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }) as any[][];
        
        // 验证表头
        const headers = jsonData[0];
        const expectedHeaders = ['品牌', '规格', '直径(英寸)', '螺距(英寸)', '叶片数', '重量(g)', '材质', '推力系数', '功率系数', '效率(%)', '价格(¥)', '备注'];
        
        if (!validateHeaders(headers, expectedHeaders)) {
          throw new Error('桨叶数据Excel表头格式不正确');
        }
        
        const propellers: Propeller[] = [];
        for (let i = 1; i < jsonData.length; i++) {
          const row = jsonData[i];
          if (row[0] && row[1]) {
            propellers.push({
              id: generateId(),
              brand: row[0] || '',
              spec: row[1] || '',
              diameter: parseFloat(row[2]) || 0,
              pitch: parseFloat(row[3]) || 0,
              blades: parseInt(row[4]) || 2,
              weight: parseFloat(row[5]) || 0,
              material: row[6] || '',
              thrustCoeff: parseFloat(row[7]) || 0,
              powerCoeff: parseFloat(row[8]) || 0,
              efficiency: parseFloat(row[9]) || 0,
              price: parseFloat(row[10]) || 0,
              notes: row[11] || ''
            });
          }
        }
        
        resolve(propellers);
      } catch (error) {
        reject(error);
      }
    };
    reader.readAsArrayBuffer(file);
  });
};

// 表头验证函数
const validateHeaders = (actualHeaders: any[], expectedHeaders: string[]): boolean => {
  if (actualHeaders.length < expectedHeaders.length) return false;
  
  for (let i = 0; i < expectedHeaders.length; i++) {
    if (actualHeaders[i] !== expectedHeaders[i]) return false;
  }
  
  return true;
}; 